import { msalInstance } from "./msalConfig"

/** Runtime identity only; never use a display organization or expose account IDs in Redux. */
export function staffAccountKey(): string | null {
  const account = msalInstance.getActiveAccount()
  return account ? JSON.stringify([account.environment, account.homeAccountId, account.localAccountId, account.tenantId]) : null
}
